<app-elevation-section [title]="languageService.LNG('Label.Addition')">
    <div class="grid-totals-wrapper">
        <dx-select-box
          [dataSource]="additionTypes"
          displayExpr="Code"
          searchExpr="Code"
          valueExpr="AdditionTypeId"
          [searchEnabled]="true"
          [showClearButton]="true"
          [(value)]="newAddition.AdditionTypeId"
          [readOnly]="isEditingDisabled"
          placeholder="{{languageService.LNG('Label.Addition')}}">
        </dx-select-box>
        <dx-text-box placeholder="{{languageService.LNG('Label.Value')}}" 
          [(value)]="newAddition.Value" 
          [readOnly]="isEditingDisabled"
          (onEnterKey)="createNewAddition()">
        </dx-text-box>
    </div>

    <dx-data-grid #datagriddx [dataSource]="gridDataSource"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                [height]="225"
                style="padding-bottom: 10px;"
                (onRowRemoving)="onRowRemoving($event)"
                (onRowUpdating)="onRowUpdating($event)"
                (onEditorPreparing)="onEditorPreparing($event)">
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-editing mode="cell"
                    [allowUpdating]="!isEditingDisabled"
                    [allowAdding]="false"
                    [allowDeleting]="!isEditingDisabled"
                    [useIcons]="true">
        </dxo-editing>
        <dxo-load-panel [enabled]="true"></dxo-load-panel>
        <dxo-scrolling mode="virtual"></dxo-scrolling>

        <dxi-column dataField="AdditionTypeId" caption="{{languageService.LNG('Label.Addition')}}" [setCellValue]="setAdditionTypeValue"
                    cellTemplate="additionTypeCellTemplate" editCellTemplate="additionTypeEditCellTemplate" ></dxi-column>
        <dxi-column dataField="Value" caption="{{languageService.LNG('Label.Value')}}" [width]="75" ></dxi-column>
        <dxi-column dataField="UnitCode" [allowEditing]="false" caption="" [width]="50" ></dxi-column>
        <div *dxTemplate="let data of 'additionTypeCellTemplate'">
            {{data.data.Code}}
        </div>
        <div *dxTemplate="let data of 'additionTypeEditCellTemplate'">
                <dx-select-box [dataSource]="additionTypeDataSource"
                            displayExpr="Code"
                            searchExpr="Code"
                            [grouped]="true"
                            valueExpr="AdditionTypeId"
                            (onValueChanged)="onAdditionTypeChanged($event, data)"
                            [value]="data.data.AdditionTypeId">
                </dx-select-box>
        </div>
        <div *dxTemplate="let data of 'headerTitle'">
            <span style="font-size: 20px;" >{{this.languageService.LNG("Label.Addition")}}</span>
        </div>
    </dx-data-grid>
</app-elevation-section>
